import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-immersive-promo",
  "use": "icon-soc-mall-immersive-promo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-immersive-promo\">\r\n<g fill=\"currentColor\">\r\n  <rect x=\"140\" y=\"180\" width=\"320\" height=\"220\" rx=\"24\" />\r\n  <rect x=\"564\" y=\"180\" width=\"320\" height=\"220\" rx=\"24\" />\r\n  <rect x=\"140\" y=\"520\" width=\"744\" height=\"280\" rx=\"28\" opacity=\"0.55\" />\r\n  <circle cx=\"280\" cy=\"640\" r=\"36\" />\r\n  <circle cx=\"512\" cy=\"640\" r=\"36\" />\r\n  <circle cx=\"744\" cy=\"640\" r=\"36\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-immersive-promo.svg
// module id = e90Y
// module chunks = 477